import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "table-responsive overflow-auto pt-4" }
const _hoisted_4 = { class: "table table-striped" }
const _hoisted_5 = {
  class: "text-truncate",
  style: {"max-width":"250px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "pl-3" }
const _hoisted_8 = {
  key: 0,
  class: "status-pill green p-2 mr-2",
  "data-toggle": "tooltip",
  "data-original-title": "",
  title: ""
}
const _hoisted_9 = {
  key: 1,
  class: "status-pill red p-2 mr-2",
  "data-toggle": "tooltip",
  "data-original-title": "",
  title: ""
}
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "p-2 bg-light",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "p-2 bg-light",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_17 = {
  class: "p-2 bg-light",
  style: {"white-space":"pre-wrap"}
}

import systemMonitoringService from '@/api/SystemMonitoring';
import Pagination from '@/components/Pagination.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import PerPage from '@/components/PerPage.vue';
import {onMounted, ref} from 'vue';
import Search from "@/views/App/SystemMonitoring/SystemExceptionLog/Search.vue";
import {getSortIconClass} from '@/shared/functions';

export interface SystemExceptionLog {
  id: number;
  title: string | null;
  message: string | null;
  exceptionClass: string | null;
  file: string | null;
  line: number | null;
  trace: string | null;
  context: Record<string, any> | null;
  level: string | null;
  notified: boolean;
  createdAt: string;
}

interface PaginationData {
  total_pages: number;
  current_page: number;
  items_per_page: number;
}

interface SystemExceptionLogListResponse {
  data: SystemExceptionLog[];
  pagination: PaginationData;
}

interface Filters {
  level: string;
  exceptionClass: string;
  notified: string;
  dateFrom: string;
  dateTo: string;
  searchTerm: string;
  sortBy: string;
  orderBy: string;
}

interface DropdownOption {
  value: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const systemExceptionLogList = ref<SystemExceptionLogListResponse | any>([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const showModal = ref(false);
const selectedLog = ref<SystemExceptionLog | null>(null);

const filters = ref<Filters>({
  level: '',
  exceptionClass: '',
  notified: '',
  dateFrom: '',
  dateTo: '',
  searchTerm: '',
  sortBy: 'createdAt',
  orderBy: 'DESC',
});

const levelDropdown = ref<DropdownOption[]>([
  {value: 'error', label: 'Error'},
  {value: 'critical', label: 'Critical'},
]);

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy: filters.value.orderBy === 'DESC' || filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  getSystemExceptionLogList();
}

function showDetails(log: SystemExceptionLog) {
  selectedLog.value = log;
  showModal.value = true;
}

async function getSystemExceptionLogList(page = 1, perPage?: number, passedFilters?: Filters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = systemExceptionLogList.value?.pagination?.items_per_page;

  try {
    const {data} = await systemMonitoringService.getSystemExceptionLogs({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    systemExceptionLogList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await getSystemExceptionLogList()
  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "d-flex justify-content-between" }, [
              _createElementVNode("h6", { class: "element-header" }, " System exception log ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "form-header mb-4" }, " System exception log list ", -1)),
              _createVNode(Search, {
                class: "mb-3",
                filters: filters.value,
                loading: isSearching.value,
                levelDropdown: levelDropdown.value,
                onSearch: getSystemExceptionLogList
              }, null, 8, ["filters", "loading", "levelDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getSystemExceptionLogList
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (sortBy('createdAt')))
                        }, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", null, "Created at", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('createdAt'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (sortBy('level')))
                        }, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Level", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('level'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (sortBy('exceptionClass')))
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("span", null, "Exception class", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('exceptionClass'))
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('title')))
                        }, [
                          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Title", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('title'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, "Message", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("th", null, "File", -1)),
                      _createElementVNode("th", null, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('notified')))
                        }, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Notified", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(getIconClass('notified'))
                          }, null, 2)
                        ])
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("th", { style: {"text-align":"right"} }, "Details", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemExceptionLogList.value.data, (log) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: log.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(log?.createdAt), 1),
                        _createElementVNode("td", null, _toDisplayString(log?.level), 1),
                        _createElementVNode("td", null, _toDisplayString(log?.exceptionClass), 1),
                        _createElementVNode("td", null, _toDisplayString(log?.title), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(log?.message), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(log?.file), 1),
                          (log?.line)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, ":" + _toDisplayString(log?.line), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_7, [
                            (log?.notified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9))
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_10, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: ($event: any) => (showDetails(log))
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "os-icon os-icon-info" }, null, -1)
                          ]))], 8, _hoisted_11)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (systemExceptionLogList.value?.pagination?.total_pages > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: systemExceptionLogList.value?.pagination?.total_pages,
                    currentPage: systemExceptionLogList.value?.pagination?.current_page,
                    totalItems: systemExceptionLogList.value?.pagination?.total_items,
                    perPage: systemExceptionLogList.value?.pagination?.items_per_page,
                    onPagechanged: getSystemExceptionLogList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(Modal, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
        title: "Exception details",
        hideFooter: true,
        sizeModal: "modal-lg"
      }, {
        default: _withCtx(() => [
          (selectedLog.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("p", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Title:", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedLog.value?.title), 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Exception class:", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedLog.value?.exceptionClass), 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Level:", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedLog.value?.level), 1)
                ]),
                _createElementVNode("p", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("strong", null, "File:", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedLog.value?.file), 1),
                  (selectedLog.value?.line)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, ":" + _toDisplayString(selectedLog.value?.line), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Created at:", -1)),
                  _createTextVNode(" " + _toDisplayString(selectedLog.value?.createdAt), 1)
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Message:")
                ], -1)),
                _createElementVNode("pre", _hoisted_14, _toDisplayString(selectedLog.value?.message), 1),
                (selectedLog.value?.context && Object.keys(selectedLog.value.context).length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("strong", null, "Context:", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (selectedLog.value?.context && Object.keys(selectedLog.value.context).length)
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_16, _toDisplayString(selectedLog.value?.context), 1))
                  : _createCommentVNode("", true),
                _cache[24] || (_cache[24] = _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Trace:")
                ], -1)),
                _createElementVNode("pre", _hoisted_17, _toDisplayString(selectedLog.value?.trace), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})